// extracted by mini-css-extract-plugin
module.exports = {"returns__notification":"notification_returns__notification__fD7ql","withLinks":"notification_withLinks__ftp_c","notification__links":"notification_notification__links__2jsZ5"};